import { createContext } from 'react';

const GoalContext = createContext({
  goals: [],
  loading: false,
  error: null,
  fetchGoals: () => {},
  addGoal: () => {},
  updateGoal: () => {},
  updateGoalProgress: () => {},
  deleteGoal: () => {}
});

export default GoalContext;
